function hasInputValue(value: string): boolean {
  return value.trim().length > 0
}

export function shouldEnableCountAvailableDaysOnly(dateRange: string): boolean {
  return hasInputValue(dateRange)
}

export function resolveCountAvailableDaysOnly(
  userIntent: boolean,
  dateRange: string
): boolean {
  return userIntent && shouldEnableCountAvailableDaysOnly(dateRange)
}
